import { Alert, Button, Col, Container, Modal, Row } from 'react-bootstrap';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FormReqUserEditField } from '../../common/Forms';
import { ReqUser } from './ReqUser';
import { validateRequestUsers } from '../../../util';
import { RequestUsersRow } from './RequestUsersRow';
import { ExpandableCard } from '../../common/ExpandableCard/ExpandableCard';

export function RequestUsers(props) {
    const { request, executing, errors, addUser, rmUser, updateUser, clearErrors, readOnly } = props;
    const [editUser, setEditUser] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const errorMes = useMemo(() => validateRequestUsers(request), [request]);

    useEffect(() => {
        clearErrors();
    }, [editUser, clearErrors]);

    useEffect(() => {
        return () => clearErrors();
    }, [clearErrors]);

    useEffect(() => {
        if (!executing && !errors) setEditUser(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [executing]);

    const handleAddUserClick = useCallback(() => {
        setEditUser('new');
    }, []);
    const handleCancelClick = useCallback(() => {
        if (executing) return;
        setEditUser(null);
    }, [executing]);
    const handleUserSubmit = useCallback(
        (values) => {
            if (executing) return;
            if (editUser === 'new') addUser({ requestId: +request.id, ...values });
            else updateUser({ requestId: +request.id, ...values });
        },
        [executing, editUser, addUser, request, updateUser]
    );
    const handleCloseModal = useCallback(() => {
        setSelectedUser(null);
        setShowModal(false);
    }, []);
    const handleDelUserClick = useCallback((reqUser) => {
        setSelectedUser(reqUser.user);
        setShowModal(true);
    }, []);
    const handleConfirmDelUserClick = useCallback(() => {
        if (selectedUser) rmUser({ requestId: request.id, userId: selectedUser.id });
        handleCloseModal();
    }, [handleCloseModal, request, rmUser, selectedUser]);
    const handleUpdateUserClick = useCallback((reqUser) => {
        setEditUser(reqUser.id);
    }, []);
    return (
        <ExpandableCard title="Участники" defaultExpanded={true}>
            <div className="small mb-3">
                Все участники перед добавлением их в заявку должны зарегистрироваться в системе. Чтобы добавить
                участника в заявку, необходимо будет указать:
                <ul className="mb-0">
                    <li>ID или email человека, под которыми он зарегистрирован в системе,</li>
                    <li>фамилию и имя человека (так, как они указанны в его профиле).</li>
                </ul>
                Без этих данных добавить участника нельзя.
            </div>
            {errorMes && <Alert variant="danger">{errorMes}</Alert>}
            <Container>
                <Row className="d-none d-sm-flex mb-2 font-weight-bold">
                    <Col sm={1}>№</Col>
                    <Col sm={3}>Участник</Col>
                    <Col sm={2}>Роль</Col>
                    <Col sm={4}>Персонаж/пояснение</Col>
                    <Col sm={2} />
                </Row>
                {request.users.map((reqUser, i) =>
                    editUser === reqUser.id ? (
                        <FormReqUserEditField
                            request={request}
                            reqUser={reqUser}
                            onCancel={handleCancelClick}
                            onSubmit={handleUserSubmit}
                            errors={errors}
                            clearErrors={clearErrors}
                            submitting={executing}
                            key={reqUser.id}
                        />
                    ) : (
                        <RequestUsersRow
                            key={reqUser.id}
                            index={i}
                            request={request}
                            reqUser={reqUser}
                            readOnly={readOnly}
                            onUpdate={handleUpdateUserClick}
                            onDelete={handleDelUserClick}
                        />
                    )
                )}
            </Container>
            {!readOnly && (
                <div>
                    {editUser === 'new' ? (
                        <FormReqUserEditField
                            request={request}
                            onCancel={handleCancelClick}
                            onSubmit={handleUserSubmit}
                            errors={errors}
                            clearErrors={clearErrors}
                            submitting={executing}
                        />
                    ) : (
                        <div className="text-right">
                            <Button variant="outline-primary" className="mt-4 px-4" onClick={handleAddUserClick}>
                                Добавить участника
                            </Button>
                        </div>
                    )}
                </div>
            )}

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Подтвердите действие</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Вы уверены что хотите удалить участника <ReqUser user={selectedUser} />?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Отмена
                    </Button>
                    <Button variant="primary" onClick={handleConfirmDelUserClick}>
                        Уверен
                    </Button>
                </Modal.Footer>
            </Modal>
        </ExpandableCard>
    );
}
